import { render, staticRenderFns } from "./ProductExa.vue?vue&type=template&id=ab9b334a&scoped=true"
import script from "./ProductExa.vue?vue&type=script&lang=js"
export * from "./ProductExa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9b334a",
  null
  
)

export default component.exports